// Copyright (c) 2018 Deere & Company

import ClaimUseAmount from '@deere/cps-it.warranty-model-factory/lib/claim-use-amount';
import _ from 'lodash';

export const updateClaimUseAmountsArray = (claimUseAmounts, allowedUseAmountUnits, updateClaimUseAmountsActionType) =>

    dispatch => {

        const useAmountUnitsInClaim = claimUseAmounts.map(useAmount => useAmount.unit);

        const unitsMissingFromClaim = _.differenceBy(allowedUseAmountUnits, useAmountUnitsInClaim, 'key');

        const useAmountsToPushToClaim = unitsMissingFromClaim.map(unit => new ClaimUseAmount({
            amount: '',
            unit
        }));

        const updatedClaimUseAmountsArray = claimUseAmounts.concat(useAmountsToPushToClaim);

        dispatch({
            type: updateClaimUseAmountsActionType,
            useAmounts: updatedClaimUseAmountsArray
        });

    };



// WEBPACK FOOTER //
// ./src/claim/shared/services/update-claim-use-amounts-array.js